import logo from "./logo.svg";
import "./App.css";
import Registration from "./components/Registration/Registration";
import Invoice from "./components/Invoice/Invoice";
import ListCustomers from "./components/Customer/ListCustomers";
import { Routes, Route, Navigate } from "react-router";
import Login from "./components/Login/Login";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/list-customers" element={<ListCustomers />} />
      <Route path="/invoice" element={<Invoice />} />
      <Route path="/login" element={<Login />} />
    </Routes>
  );
}

export default App;
